import React, { useState } from 'react';

const testimonials = [
  {
    name: 'Erik Haugen',
    role: 'Lastebilsjåfør, Trondheim',
    quote: 'Bomkalkulatoren sparer meg for tusenvis av kroner i måneden. Jeg kjører strekningen Oslo–Bergen ukentlig og kan nå planlegge ruten med nøyaktige kostnader på forhånd.',
    rating: 5,
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_19a866b95-1772187879367.png',
    imageAlt: 'Norwegian truck driver Erik Haugen smiling in front of his vehicle in Trondheim',
    plan: 'Premium',
    since: '2024',
    highlight: 'tusenvis av kroner'
  },
  {
    name: 'Ingrid Solberg',
    role: 'Pendler, Bergen',
    quote: 'Veikartfunksjonen er uunnværlig om vinteren. Jeg ser vegforholdene live og kan velge tryggere ruter når det er glatt. Har unngått flere ulykker takket være sanntidsvarsler.',
    rating: 5,
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_15275c3e7-1772187882617.png',
    imageAlt: 'Norwegian commuter Ingrid Solberg standing by her car on a snowy Bergen road',
    plan: 'Normal',
    since: '2025',
    highlight: 'unngått flere ulykker'
  },
  {
    name: 'Lars Kristiansen',
    role: 'Taxisjåfør, Oslo',
    quote: 'Som taxisjåfør er sanntidstrafikk alt. NordPass gir meg et konkurransefortrinn — jeg ser kamerafeed fra veiene og velger alltid den raskeste ruten for kundene mine.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1497564917593-64853ce56b98',
    imageAlt: 'Oslo taxi driver Lars Kristiansen in his vehicle with city lights in background',
    plan: 'Premium',
    since: '2024',
    highlight: 'konkurransefortrinn'
  },
  {
    name: 'Astrid Moen',
    role: 'Familiemor, Stavanger',
    quote: 'Gratis-planen er perfekt for oss. Vi har to biler registrert og kan se bomkostnader for helgeturer. Enkelt, norsk og pålitelig — akkurat det vi trenger.',
    rating: 4,
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_100e832d3-1772187879348.png',
    imageAlt: 'Norwegian mother Astrid Moen smiling outdoors in Stavanger with fjord in background',
    plan: 'Gratis',
    since: '2025',
    highlight: 'Enkelt, norsk og pålitelig'
  }
];

const TestimonialsSection = () => {
  const [active, setActive] = useState(0);
  const t = testimonials?.[active];

  return (
    <section style={{ background: '#080D14', padding: '80px 0 100px', position: 'relative', overflow: 'hidden' }}>
      {/* Faded background landscape */}
      <div style={{ position: 'absolute', right: 0, top: 0, width: '40%', height: '100%', overflow: 'hidden' }}>
        <img
          src="https://images.unsplash.com/photo-1614295832181-4176b567e8fb"
          alt="Misty Norwegian fjord landscape with mountains reflected in still water at dawn"
          style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.06, filter: 'grayscale(100%)' }}
        />
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to right, #080D14 0%, transparent 50%)' }} />
      </div>
      <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 5%', position: 'relative', zIndex: 1 }}>

        {/* Section header */}
        <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', marginBottom: '50px', flexWrap: 'wrap', gap: '20px' }}>
          <div>
            <div style={{
              fontFamily: 'monospace', fontSize: '0.6rem',
              letterSpacing: '0.3em', color: 'rgba(59,111,212,0.6)',
              textTransform: 'uppercase', marginBottom: '14px'
            }}>04 — Brukere</div>
            <h2 style={{
              fontFamily: '"Arial Black", Impact, sans-serif',
              fontSize: 'clamp(2rem, 5.5vw, 5rem)',
              fontWeight: 900, color: '#EEF0F2',
              letterSpacing: '-0.04em', lineHeight: 0.9,
              textTransform: 'uppercase', margin: 0
            }}>HVA NORSKE<br />SJÅFØRER SIER</h2>
          </div>
          <div style={{
            fontFamily: 'Georgia, serif', fontStyle: 'italic',
            fontSize: '0.9rem', color: 'rgba(138,149,163,0.5)',
            maxWidth: '200px', textAlign: 'right', lineHeight: 1.6
          }}>Ekte historier fra ekte brukere på norske veier</div>
        </div>

        {/* Main testimonial layout — responsive */}
        <div className="testimonials-grid" style={{ display: 'grid', gridTemplateColumns: '1.2fr 1fr', gap: '60px', alignItems: 'start' }}>

          {/* Left: big quote */}
          <div>
            <div style={{
              fontFamily: 'Georgia, "Times New Roman", serif',
              fontSize: '8rem', color: '#3B6FD4',
              lineHeight: 0.7, marginBottom: '-20px',
              opacity: 0.3, userSelect: 'none'
            }}>&ldquo;</div>

            <blockquote style={{
              fontFamily: 'Georgia, serif', fontStyle: 'italic',
              fontSize: 'clamp(1rem, 2.2vw, 1.7rem)',
              color: '#EEF0F2', lineHeight: 1.65,
              margin: '0 0 36px',
              borderLeft: '3px solid #3B6FD4',
              paddingLeft: '28px'
            }}>
              {t?.quote?.split(t?.highlight)?.map((part, i, arr) => (
                <React.Fragment key={i}>
                  {part}
                  {i < arr?.length - 1 && (
                    <em style={{
                      fontStyle: 'normal',
                      background: 'rgba(59,111,212,0.2)',
                      color: '#EEF0F2',
                      padding: '0 4px'
                    }}>{t?.highlight}</em>
                  )}
                </React.Fragment>
              ))}
            </blockquote>

            {/* Author row */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
              <div style={{
                background: '#1a1a1a',
                padding: '6px 6px 28px',
                transform: 'rotate(-2deg)',
                boxShadow: '0 8px 24px rgba(0,0,0,0.6)',
                flexShrink: 0
              }}>
                <img
                  src={t?.image}
                  alt={t?.imageAlt}
                  style={{ width: '64px', height: '64px', objectFit: 'cover', display: 'block' }}
                />
              </div>
              <div>
                <div style={{
                  fontFamily: '"Arial Black", sans-serif',
                  fontSize: '0.9rem', fontWeight: 900,
                  color: '#EEF0F2', letterSpacing: '-0.01em',
                  textTransform: 'uppercase'
                }}>{t?.name}</div>
                <div style={{
                  fontFamily: 'Georgia, serif', fontStyle: 'italic',
                  fontSize: '0.8rem', color: '#8A95A3', marginTop: '3px'
                }}>{t?.role}</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '8px', flexWrap: 'wrap' }}>
                  <span style={{
                    fontFamily: 'monospace', fontSize: '0.55rem',
                    letterSpacing: '0.12em', color: '#3B6FD4',
                    border: '1px solid rgba(59,111,212,0.3)',
                    padding: '2px 8px', textTransform: 'uppercase'
                  }}>NordPass {t?.plan}</span>
                  <span style={{
                    fontFamily: 'Georgia, serif', fontStyle: 'italic',
                    fontSize: '0.7rem', color: 'rgba(138,149,163,0.4)'
                  }}>siden {t?.since}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right: testimonial selector cards */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {testimonials?.map((item, i) => (
              <button
                key={i}
                onClick={() => setActive(i)}
                style={{
                  background: active === i ? 'rgba(59,111,212,0.08)' : 'transparent',
                  border: active === i ? '1px solid rgba(59,111,212,0.25)' : '1px solid rgba(255,255,255,0.04)',
                  padding: '16px 20px',
                  cursor: 'pointer', textAlign: 'left',
                  display: 'flex', alignItems: 'center', gap: '16px',
                  transition: 'all 200ms ease',
                  transform: active === i ? 'translateX(4px)' : 'none'
                }}
              >
                <div style={{
                  background: '#1a1a1a',
                  padding: '4px 4px 16px',
                  transform: i % 2 === 0 ? 'rotate(-1deg)' : 'rotate(1deg)',
                  flexShrink: 0
                }}>
                  <img
                    src={item?.image}
                    alt={item?.imageAlt}
                    style={{ width: '40px', height: '40px', objectFit: 'cover', display: 'block', opacity: active === i ? 1 : 0.5 }}
                  />
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{
                    fontFamily: active === i ? '"Arial Black", sans-serif' : 'Georgia, serif',
                    fontStyle: active === i ? 'normal' : 'italic',
                    fontSize: '0.875rem',
                    fontWeight: active === i ? 900 : 400,
                    color: active === i ? '#EEF0F2' : '#8A95A3',
                    letterSpacing: active === i ? '-0.01em' : '0',
                    textTransform: active === i ? 'uppercase' : 'none',
                    transition: 'all 200ms ease',
                    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'
                  }}>{item?.name}</div>
                  <div style={{
                    fontFamily: 'Georgia, serif', fontStyle: 'italic',
                    fontSize: '0.75rem', color: 'rgba(138,149,163,0.5)', marginTop: '2px',
                    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'
                  }}>{item?.role}</div>
                </div>
                {active === i && (
                  <div style={{
                    fontFamily: 'monospace', fontSize: '0.55rem',
                    color: '#3B6FD4', letterSpacing: '0.1em', flexShrink: 0
                  }}>→</div>
                )}
              </button>
            ))}

            <div style={{
              marginTop: '20px', paddingLeft: '22px',
              borderLeft: '1px solid rgba(255,255,255,0.06)'
            }}>
              <div style={{
                fontFamily: 'Georgia, serif', fontStyle: 'italic',
                fontSize: '0.75rem', color: 'rgba(138,149,163,0.35)',
                lineHeight: 1.6, transform: 'rotate(-0.5deg)'
              }}>Alle anmeldelser er verifiserte brukere<br />fra NordPass-plattformen.</div>
            </div>
          </div>
        </div>
      </div>
      <style>{`
        @media (max-width: 767px) {
          .testimonials-grid { grid-template-columns: 1fr !important; gap: 40px !important; }
        }
      `}</style>
    </section>
  );
};

export default TestimonialsSection;